import * as ROUTES from '../common/routes';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import React, { useState } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation } from 'react-router-dom';

interface IProps {
  title?: string;
  expanded?: boolean;
  defaultExpanded?: boolean;
  children?: any;
  linkData?: any;
}

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      accordionTitleContainerStyle: {
        position: 'relative',
        width: '100%',
        flexDirection: 'row',
      },
      totalItemsStyle: {
        marginLeft: '6px',
        color: COLORS.textGray,
      },
      '@global': {
        '.MuiAccordion-root': {
          width: '100%',
          background: 'none !important',
          '&::before': {
            display: 'none !important',
          },
        },
        '.MuiAccordionSummary-root': {
          flexDirection: 'row-reverse',
          alignItems: 'flex-start !important',
          padding: '0 !important',
        },
        '.MuiAccordionSummary-content': {
          fontWeight: FONT_WEIGHT.medium,
          fontSize: '20px',
          fontFamily: FONTS.alegreya,
          color: COLORS.appBlue,
          lineHeight: '24px',
        },
        '.MuiAccordionSummary-expandIconWrapper': {
          marginTop: '12px',
          marginRight: '10px',
        },
        '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
          transform: 'rotate(90deg) !important',
        },
        '.MuiAccordionDetails-root': {
          padding: '0 0 0 30px !important',
        },
      },
    })
);

const SurveyAccordion = ({
  title,
  expanded,
  defaultExpanded,
  children,
  linkData,
}: IProps): JSX.Element => {
  const classes = useStyles();
  const [isExpanded, setExpanded] = useState(expanded);
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  const onChange = (event) => {
    setExpanded(!isExpanded);
  };

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    navigate({ pathname: linkData.link, search });
  };

  return (
    <MuiAccordion
      disableGutters
      elevation={0}
      square
      expanded={isExpanded}
      onChange={onChange}
      defaultExpanded={defaultExpanded}
    >
      <MuiAccordionSummary
        expandIcon={
          <ArrowForwardIosSharpIcon
            sx={{ fontSize: '20px', color: COLORS.appBlue }}
          />
        }
      >
        <div className={classes.accordionTitleContainerStyle}>
          {title}
          {linkData && (
            <span className={classes.totalItemsStyle} onClick={onClick}>
              {linkData.title}
            </span>
          )}
        </div>
      </MuiAccordionSummary>
      <MuiAccordionDetails>{children}</MuiAccordionDetails>
    </MuiAccordion>
  );
};

export default SurveyAccordion;
